// This is only used for activities and slides done in the content tool old architecture.
// For activities that are in the new microservices architecture use activityTypes enum.
export default {
	SLIDE_TYPE_ID_AUDIO: 1,
	SLIDE_TYPE_ID_BBC_VIDEO: 2,
	SLIDE_TYPE_ID_COLLABORATE: 3,
	SLIDE_TYPE_ID_DRAW_IT: 4,
	SLIDE_TYPE_ID_FIELD_TRIP: 5,
	SLIDE_TYPE_ID_FILL_IN_THE_BLANKS: 6,
	SLIDE_TYPE_ID_GRAPHING_CALCULATOR: 7,
	SLIDE_TYPE_ID_LIVE_TWITTER_STREAM: 8,
	SLIDE_TYPE_ID_MATCHING_PAIRS: 9,
	SLIDE_TYPE_ID_MEMORY_TEST: 10,
	SLIDE_TYPE_ID_NEARPOD_3D: 11,
	SLIDE_TYPE_ID_OPEN_ENDED_QUESTION: 12,
	SLIDE_TYPE_ID_PDF_VIEWER: 13,
	SLIDE_TYPE_ID_POLL: 14,
	SLIDE_TYPE_ID_QUIZ: 15,
	SLIDE_TYPE_ID_SIMULATION: 16,
	SLIDE_TYPE_ID_SLIDE: 17,
	SLIDE_TYPE_ID_SLIDESHOW: 18,
	SLIDE_TYPE_ID_SWAY: 19,
	SLIDE_TYPE_ID_TIME_TO_CLIMB: 20,
	SLIDE_TYPE_ID_VIDEO: 21,
	SLIDE_TYPE_ID_WEB_CONTENT: 22,
	SLIDE_TYPE_ID_FLOCABULARY: 23,
	SLIDE_TYPE_ID_FLIPGRID: 24,
	SLIDE_TYPE_ID_LEAD: 25,
	SLIDE_TYPE_ID_INTERACTIVE_VIDEO: 26,
}
